import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M16.9132 13.1634C16.8261 13.2508 16.7227 13.3202 16.6087 13.3675C16.4947 13.4148 16.3726 13.4392 16.2492 13.4392C16.1258 13.4392 16.0036 13.4148 15.8897 13.3675C15.7757 13.3202 15.6722 13.2508 15.5851 13.1634L9.99997 7.57828L4.41325 13.1634C4.23713 13.3396 3.99826 13.4385 3.74918 13.4385C3.50011 13.4385 3.26124 13.3396 3.08512 13.1634C2.909 12.9873 2.81006 12.7484 2.81006 12.4994C2.81006 12.2503 2.909 12.0114 3.08512 11.8353L9.33512 5.58531C9.42222 5.49791 9.52571 5.42856 9.63967 5.38124C9.75362 5.33393 9.8758 5.30957 9.99918 5.30957C10.1226 5.30957 10.2447 5.33393 10.3587 5.38124C10.4727 5.42856 10.5762 5.49791 10.6632 5.58531L16.9132 11.8353C17.0006 11.9224 17.07 12.0259 17.1173 12.1399C17.1646 12.2538 17.189 12.376 17.189 12.4994C17.189 12.6228 17.1646 12.7449 17.1173 12.8589C17.07 12.9728 17.0006 13.0763 16.9132 13.1634Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconChevronUp'

export const IconChevronUp = memo(themed(Icon))
